export default {
  data: () => ({
    translations: {
      title_points: {
        el: 'Αναλογία Offline-Online Points',
        en: 'Offline-Online Points Relation',
        it: 'Rapporto punti Offline-Online',
      },
      title_cashback: {
        el: 'Αναλογία Offline-Online Cashback',
        en: 'Offline-Online Cashback Relation',
        it: 'Rapporto cashback Offline-Online',
      },
      info_points: {
        el: 'Παρακαλώ ορίστε την αντιστοιχία Offline-Online πόντων που θα δίνονται στον χρήστη (π.χ.: Αν επιλέξετε 30%, αν οι online πόντοι είναι 100, τότε οι offline πόντοι θα είναι 30).',
        en: `
                    Please specify the Offline-Online relation for points that will be given
                    to the user (eg: If you select 30%, if the online points are 100, then
                    the offline points will be 30).
                `,
        it: "Si prega di specificare i punti Offline-Online da dare all'utente (ad esempio: se si seleziona 30%, se i punti online sono 100, allora i punti offline saranno 30).",
      },
      info_cashback: {
        el: 'Παρακαλώ ορίστε την αντιστοιχία Offline-Online cashback που θα δίνονται στον χρήστη (π.χ.: Αν επιλέξετε 30%, αν το online cashback είναι 100, τότε το offline cashback θα είναι 30).',
        en: `
                    Please specify the Offline-Online relation for cashback that will be given
                    to the user (eg: If you select 30%, if the online cashback is 100, then
                    the offline cashback will be 30).
                `,
        it: "Si prega di specificare il cashback Offline-Online da dare all'utente (ad esempio: se si seleziona 30%, se il cashback online è 100, allora il cashback offline sarà 30).",
      },
      relation: {
        el: 'Αναλογία',
        en: 'Relation:',
        it: 'Ratio',
      },
    },
  }),
};
